'use strict';

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var utils = require('../../src/utils.js');

var fromString = require('uint8arrays/from-string');

var toString = require('uint8arrays/to-string');

function keysToBinary(_x, _x2) {
  return _keysToBinary.apply(this, arguments);
}

function _keysToBinary() {
  _keysToBinary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, store) {
    var onProgress,
        db,
        upgrade,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            onProgress = _args.length > 2 && _args[2] !== undefined ? _args[2] : function () {};
            db = utils.findLevelJs(store);

            if (db) {
              _context.next = 5;
              break;
            }

            onProgress("".concat(name, " did not need an upgrade"));
            return _context.abrupt("return");

          case 5:
            onProgress("Upgrading ".concat(name));

            upgrade = function upgrade(key, value) {
              return [{
                type: 'del',
                key: key
              }, {
                type: 'put',
                key: fromString.fromString(key),
                value: value
              }];
            };

            _context.next = 9;
            return withEach(db, upgrade);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _keysToBinary.apply(this, arguments);
}

function keysToStrings(_x3, _x4) {
  return _keysToStrings.apply(this, arguments);
}

function _keysToStrings() {
  _keysToStrings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, store) {
    var onProgress,
        db,
        downgrade,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            onProgress = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : function () {};
            db = utils.findLevelJs(store);

            if (db) {
              _context2.next = 5;
              break;
            }

            onProgress("".concat(name, " did not need a downgrade"));
            return _context2.abrupt("return");

          case 5:
            onProgress("Downgrading ".concat(name));

            downgrade = function downgrade(key, value) {
              return [{
                type: 'del',
                key: key
              }, {
                type: 'put',
                key: toString.toString(key),
                value: value
              }];
            };

            _context2.next = 9;
            return withEach(db, downgrade);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _keysToStrings.apply(this, arguments);
}

function unwrap(store) {
  if (store.child) {
    return unwrap(store.child);
  }

  return store;
}

function process(_x5, _x6, _x7) {
  return _process.apply(this, arguments);
}

function _process() {
  _process = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(backends, onProgress, fn) {
    var datastores, migrated, progress, _iterator, _step, _step$value, name, store;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            datastores = Object.entries(backends).map(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                  key = _ref2[0],
                  backend = _ref2[1];

              return {
                key: key,
                backend: unwrap(backend)
              };
            }).filter(function (_ref3) {
              var key = _ref3.key,
                  backend = _ref3.backend;
              return backend.constructor.name === 'LevelDatastore';
            }).map(function (_ref4) {
              var key = _ref4.key,
                  backend = _ref4.backend;
              return {
                name: key,
                store: backend
              };
            });
            onProgress(0, "Migrating ".concat(datastores.length, " dbs"));
            migrated = 0;

            progress = function progress(message) {
              onProgress(Math.round(migrated / datastores.length * 100), message);
            };

            _iterator = _createForOfIteratorHelper(datastores);
            _context3.prev = 5;

            _iterator.s();

          case 7:
            if ((_step = _iterator.n()).done) {
              _context3.next = 21;
              break;
            }

            _step$value = _step.value, name = _step$value.name, store = _step$value.store;
            _context3.next = 11;
            return store.open();

          case 11:
            _context3.prev = 11;
            _context3.next = 14;
            return fn(name, store, progress);

          case 14:
            _context3.prev = 14;
            migrated++;
            _context3.next = 18;
            return store.close();

          case 18:
            return _context3.finish(14);

          case 19:
            _context3.next = 7;
            break;

          case 21:
            _context3.next = 26;
            break;

          case 23:
            _context3.prev = 23;
            _context3.t0 = _context3["catch"](5);

            _iterator.e(_context3.t0);

          case 26:
            _context3.prev = 26;

            _iterator.f();

            return _context3.finish(26);

          case 29:
            onProgress(100, "Migrated ".concat(datastores.length, " dbs"));

          case 30:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[5, 23, 26, 29], [11,, 14, 19]]);
  }));
  return _process.apply(this, arguments);
}

var migration = {
  version: 10,
  description: 'Migrates datastore-level keys to binary',
  migrate: function migrate(backends) {
    var onProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    return process(backends, onProgress, keysToBinary);
  },
  revert: function revert(backends) {
    var onProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    return process(backends, onProgress, keysToStrings);
  }
};

function withEach(db, fn) {
  function batch(operations, next) {
    var store = db.store('readwrite');
    var transaction = store.transaction;
    var index = 0;
    var error;

    transaction.onabort = function () {
      return next(error || transaction.error || new Error('aborted by user'));
    };

    transaction.oncomplete = function () {
      return next();
    };

    function loop() {
      var op = operations[index++];
      var key = op.key;
      var req;

      try {
        req = op.type === 'del' ? store.delete(key) : store.put(op.value, key);
      } catch (err) {
        error = err;
        transaction.abort();
        return;
      }

      if (index < operations.length) {
        req.onsuccess = loop;
      }
    }

    loop();
  }

  return new Promise(function (resolve, reject) {
    var it = db.iterator();

    var id = function id(data) {
      return data;
    };

    it._deserializeKey = it._deserializeValue = id;
    next();

    function next() {
      var handleNext = function handleNext(err, key, value) {
        if (err || key === undefined) {
          var handleEnd = function handleEnd(err2) {
            if (err2) {
              reject(err2);
              return;
            }

            resolve();
          };

          it.end(handleEnd);
          return;
        }

        batch(fn(key, value), next);
      };

      it.next(handleNext);
    }
  });
}

exports.migration = migration;